import { useState, useContext } from 'react';
import { PageContext } from '../context/page-context';

const ResponsiveSidebar = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logEvent } = useContext(PageContext);

  const openSidebar = () => {
    setSidebarOpen(true);
    logEvent(`sidebar_open`);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    logEvent(`sidebar_close`);
  };

  const onWrapperClick = () => {
    if (sidebarOpen) {
      closeSidebar();
    }
  };

  return children({
    sidebarOpen,
    openSidebar,
    onWrapperClick
  });
};

export default ResponsiveSidebar;
